import { template } from "lodash";

type ExpectedData = object | Record<string, string | Record<string, string>>;

const rawStrTemplateToStr = (str: string, data: ExpectedData, depth = 0) => {
  try {
    const compiled = template(str);
    const result = compiled(data).trim();

    if (result.match(/^\s+$/)) return "";
    if (result.match(/"\s*"/)) return result.replace(/"\s*"/g, '""');
    if (result.match(/\$\{/) && depth < 10) return rawStrTemplateToStr(result, data, depth + 1);
    return result;
  } catch (e) {
    if (e instanceof ReferenceError) {
      // Default values for fields may come from the context, if the field is not present in the context
      // we set its default value to an empty string to avoid ReferenceError if the session is not contextualized
      const missingKey = e.message.split(" ")[0];
      return rawStrTemplateToStr(str, { ...data, ...{ [missingKey]: "" } }, depth);
    }
    throw e;
  }
};

export const strTemplateToStr = (str: string, data: ExpectedData): string => {
  try {
    return rawStrTemplateToStr(str, data);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("strTemplateToStr", str, data, e);
    return `${e}`;
  }
};

export const objTemplateToObj = (obj: object, data: ExpectedData): object => {
  try {
    return JSON.parse(rawStrTemplateToStr(JSON.stringify(obj), data));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("objTemplateToObj", obj, data, e);
    return { error: `${e}` };
  }
};
